export default __webpack_public_path__ + "static/media/林草类型变化.2119a6a0.png";